import React, { useLayoutEffect, useRef, useState, ReactNode, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MetaDecorator, Button, Icon, FlexContainer, Flex, Panel, LoaderDots, Overlay, ModalSheet, CursorTooltip } from "../../components";
import { Dropdown } from "../../components/DropdownDeprecated";
import Parallax from 'parallax-js';
import { isTablet, isMobile } from "react-device-detect";
import moment from 'moment';

// import { SwapForm } from "../layouts";
import classnames from "classnames/bind";
import styles from "./Download.module.scss";
import { Info } from "../../interfaces";

import DeBotClient from "../../client/client";

const cnb = classnames.bind(styles);

const Card = ({
  className,
  title,
  disabled,
  link,
  icon
} : {
  className?: string,
  title?: ReactNode,
  link?: string,
  disabled?: boolean,
  icon?: ReactNode
}) => (
  <div className={cnb("card", className)}>
    {disabled
      ? <span className={cnb("card-title", "color-faded", "action", "action-normal")}>{icon} {title}</span>
      : <a href={link} className={cnb("card-title", "action", "action-normal")}>{icon} {title}</a>
    }
  </div>
  );

export const Download:React.FunctionComponent<{}> = () => {

  const [showTable, setShowTable] = useState<boolean>(false);
  const [info, setInfo] = useState<Info>();

  const [endOfDay, setEndOfDay] = useState<number>(0);
  const [duration, setDuration] = useState<moment.Duration>();

  const ref1 = useRef<SVGSVGElement>(null);
  const ref2 = useRef<SVGSVGElement>(null);

  const [toast, setToast] = useState<boolean>(true);
  const [tomorrowPrice, setTomorrowPrice] = useState<string>("");

    return (
      <>
      <MetaDecorator
        title="Download app · Ever Surf"
        description="Get self—custody Everscale browser for any device"
        keywords="ever, surf, token, everscale, utility, bridge, ever, blockchain, community, install, download, app"
      />
      {/* <Toast
          header={<div className="title title-small2">
            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 13.7142V6.00254C14 6.00163 13.9989 6.00119 13.9983 6.00185L10 10.2858V17.9975C10 17.9984 10.0011 17.9988 10.0017 17.9981L14 13.7142Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
              <path d="M21 13.7142V6.00254C21 6.00163 20.9989 6.00119 20.9983 6.00185L17 10.2858V17.9975C17 17.9984 17.0011 17.9988 17.0017 17.9981L21 13.7142Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
              <path d="M7 13.7142V6.00254C7 6.00163 6.99889 6.00119 6.99827 6.00185L3 10.2858V17.9975C3 17.9984 3.00111 17.9988 3.00173 17.9981L7 13.7142Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
            </svg>Web 3.0 compatible</div>}
            
          close={true}
          variant={"dark"}
          show={toast}
          onClose={() => {setToast(false)}}
        >
          <a href="https://uri.ever.surf/debot/0:be358a444895ed16532a3ec901ea25d6f1f766bf5921833e4cec87f8b8dd7aba" rel="noopener noreferrer nofollow" target="_blank">
            <div className="action action-normal">Ever Surf Token Debot</div>
            <div className="parapgraph parapgraph-small">Address: 0:be3 ···· 7aba</div>
          </a>
        </Toast> */}
      <Container fluid>
        <Row className={cnb("hero")}>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 12, order: 1 }} lg={{ span: 12 }} xl={{ span: 12 }}>
            <div className="subheader title title-normal">Download app & extension</div>
            <h1 className="header title title-great">Get self—custody wallet for any device</h1>
          </Col>
        </Row>
      </Container>
      <Container
        className={cnb("download")}
        fluid
      >
        <Panel
          className={cnb("download-panel")}
        >
          <h6 className="header title title-large">Surf for mobile<sup className="action action-small color-green">the safest</sup></h6>
          <FlexContainer
            className={cnb("cards-flex")}
            direction={"row"}
            justify={"flex-start"}
            align={"stretch"}
          >
            <Flex>
              <Card
                title={"Google Play"}
                link={"https://play.google.com/store/apps/details?id=surf.ton"}
                icon={<Icon icon={"google-play"}/>}
              />
            </Flex>
            <Flex>
              <Card
                title={"App Store"}
                link={"https://apps.apple.com/app/id1481986831"}
                icon={<Icon icon={"app-store"}/>}
              />
            </Flex>
            <Flex>
              <Card
                title={"Download APK"}
                link={"https://github.com/tonlabs/Surf-Releases/releases"}
                icon={<Icon icon={"github"}/>}
              />
            </Flex>
          </FlexContainer>
        </Panel>
        <Panel
          className={cnb("download-panel")}
        >
          <h6 className="header title title-large">Surf for browser<sup className="action action-small color-yellow">extension</sup></h6>
          <FlexContainer
            className={cnb("cards-flex")}
            direction={"row"}
            justify={"flex-start"}
            align={"stretch"}
          >
            <Flex>
              <Card
                title={"Brave"}
                link={"https://chrome.google.com/webstore/detail/ever-surf-keeper/dfldeefnhahdhaolbkhehhlcgagefgff"}
                icon={<Icon icon={"brave"}/>}
              />
            </Flex>
            <Flex>
              <Card
                title={"Chromium"}
                link={"https://chrome.google.com/webstore/detail/ever-surf-keeper/dfldeefnhahdhaolbkhehhlcgagefgff"}
                icon={<Icon icon={"chromium"}/>}
              />
            </Flex>
            <Flex>
              <Card
                title={"Firefox"}
                link={""}
                icon={<Icon icon={"firefox"}/>}
                disabled={true}
              />
            </Flex>
          </FlexContainer>
        </Panel>
        <Panel
          className={cnb("download-panel")}
        >
          <h6 className="header title title-large">Surf for desktop<sup className="action action-small color-main">good choice</sup></h6>
          <FlexContainer
            className={cnb("cards-flex", "cards-flex-desktop")}
            direction={"row"}
            justify={"flex-start"}
            align={"stretch"}
          >
            <Flex>
              <Dropdown
                isNav={true}
                className={cnb("nav-item", "dropdown")}
                title={<><Icon icon={"windows"} className={cnb("category-icon")}/>Windows</>}
                placeholder={"Business"}
                options={[{
                  href: "https://distribution.services.ever.surf/download/channel/release/windows_64/Ever-Surf.exe",
                  title: "Windows 64 bit, .exe"
                },{
                  href: "https://distribution.services.ever.surf/download/channel/release/windows_32/Ever-Surf.exe",
                  title: "Windows 32 bit, .exe"
                }]}
              />
            </Flex>
            <Flex>
              <Dropdown
                isNav={true}
                className={cnb("nav-item", "dropdown")}
                title={<><Icon icon={"apple"} className={cnb("category-icon")}/>MacOS</>}
                placeholder={"Business"}
                // options={[{
                //   href: "https://distribution.services.ever.surf/download/channel/release/osx_arm64/Ever-Surf.dmg",
                //   title: "MacOS ARM, .dmg"
                // },{
                //   href: "https://distribution.services.ever.surf/download/channel/release/osx_64/Ever-Surf.dmg",
                //   title: "MacOS Intel, .dmg"
                // }]}
                options={[{
                  href: "https://distribution.services.ever.surf/download/channel/release/osx_64/Ever-Surf.dmg",
                  title: "MacOS Intel, .dmg"
                }]}
              />
            </Flex> 
            <Flex>
              <Dropdown
                isNav={true}
                className={cnb("nav-item", "dropdown")}
                title={<><Icon icon={"ubuntu"} className={cnb("category-icon")}/>Linux</>}
                placeholder={"Business"}
                options={[{
                  href: "https://distribution.services.ever.surf/download/channel/release/linux_64/Ever-Surf.rpm",
                  title: "CentOS 64 bit, .rpm"
                },{
                  href: "https://distribution.services.ever.surf/download/channel/release/linux_64/Ever-Surf.deb",
                  title: "Ubuntu/Debian 64 bit, .deb"
                },{
                  href: "https://distribution.services.ever.surf/download/channel/release/linux_32/Ever-Surf.rpm",
                  title: "CentOS 32 bit, .rpm"
                },{
                  href: "https://distribution.services.ever.surf/download/channel/release/linux_32/Ever-Surf.deb",
                  title: "Ubuntu/Debian 32 bit, .deb"
                },]}
              />
            </Flex>
          </FlexContainer>

          <FlexContainer
            className={cnb("cards-flex", "cards-flex-desktop-mobile")}
            direction={"row"}
            justify={"flex-start"}
            align={"stretch"}
          >
            <Flex>
              <div className={cnb("subheader")}><Icon icon={"windows"}/>Windows</div>
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/windows_64/Ever-Surf.exe">Windows 64 bit, .exe</a>
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/windows_32/Ever-Surf.exe">Windows 32 bit, .exe</a>
            </Flex>
            <Flex>
              <div className={cnb("subheader")}><Icon icon={"apple"}/>MacOS</div>
              {/* <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/osx_arm64/Ever-Surf.dmg">MacOS ARM, .dmg</a> */}
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/osx_64/Ever-Surf.dmg">MacOS Intel, .dmg</a>
            </Flex> 
            <Flex>
              <div className={cnb("subheader")}><Icon icon={"ubuntu"}/>Linux</div>
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/linux_64/Ever-Surf.rpm">CentOS 64 bit, .rpm</a>
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/linux_64/Ever-Surf.deb">Ubuntu/Debian 64 bit, .deb</a>
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/linux_32/Ever-Surf.rpm">CentOS 32 bit, .rpm</a>
              <a className="action action-normal" href="https://distribution.services.ever.surf/download/channel/release/linux_32/Ever-Surf.deb">Ubuntu/Debian 32 bit, .deb</a>
            </Flex>
          </FlexContainer>
        </Panel>
        {isTablet || isMobile
          ? <Panel
              className={cnb("download-panel", "soon")}
            >
              <h6 className="header title title-large">Surf for web<sup className="action action-small color-faded-more">deprecated*</sup></h6>
              <FlexContainer
                className={cnb("cards-flex")}
                direction={"row"}
                justify={"flex-start"}
                align={"stretch"}
              >
                <Flex>
                  <div className={cnb("card")}>
                    <span className={cnb("card-title", "color-faded", "action", "action-normal")}><Icon icon={"safari"}/> web.ever.surf</span>
                    <div className={cnb("card-subtitle", "paragraph", "paragraph-small")}><sup>*</sup>no longer available to reduce vulnerability</div>
                  </div>
                </Flex>
              </FlexContainer>
            </Panel>
          : 
          <CursorTooltip content={'No longer available to reduce vulnerability'}>
            <Panel
              className={cnb("download-panel", "deprecated")}
            >
              <h6 className="header title title-large">Surf for web<sup className="action action-small color-faded-more">deprecated</sup></h6>
              <FlexContainer
                className={cnb("cards-flex")}
                direction={"row"}
                justify={"flex-start"}
                align={"stretch"}
              >
                <Flex>
                  <Card
                    title={"web.ever.surf"}
                    disabled={true}
                    link={"https://web.ever.surf"}
                    icon={<Icon icon={"safari"}/>}
                  />
                </Flex>
              </FlexContainer>
            </Panel>
          </CursorTooltip>
        }
        <Panel
          className={cnb("download-panel")}
        >
          <h6 className="header title title-large">Want more?<sup className="action action-small color-failure">be careful</sup></h6>
          <FlexContainer
            className={cnb("cards-flex")}
            direction={"row"}
            justify={"flex-start"}
            align={"stretch"}
          >
            {/* <Flex>
              <Card
                title={"Surf Keeper"}
                link={"https://chrome.google.com/webstore/detail/ever-surf-keeper/dfldeefnhahdhaolbkhehhlcgagefgff"}
                icon={<Icon icon={"ever-surf"}/>}
              />
            </Flex> */}

            <Flex>
              <Card
                title={"Public Beta"}
                link={"https://ever.surf/beta"}
                icon={<Icon icon={"ever-surf-stroke"}/>}
              />
            </Flex>

            <Flex>
              <Card
                title={"Command Line"}
                link={"https://github.com/tonlabs/tonos-cli"}
                icon={<Icon icon={"github"}/>}
              />
            </Flex>
          </FlexContainer>
        </Panel>
      </Container>
      </>
    );
  };

export default Download;
